import { render, staticRenderFns } from "./CallDetails.vue?vue&type=template&id=7a5528af&scoped=true"
import script from "./CallDetails.vue?vue&type=script&lang=ts"
export * from "./CallDetails.vue?vue&type=script&lang=ts"
import style0 from "./CallDetails.vue?vue&type=style&index=0&id=7a5528af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5528af",
  null
  
)

export default component.exports